import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';
import { alpha } from '@mui/material/styles';

export const styles = createTypedSxStyles({
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '4px',
    padding: '8px 16px',
    boxShadow: `1px 2px 7px 0px ${alpha(capitalDesignTokens.foundations.colors.gray1000, 0.1)}`,
    height: '48px',
    backgroundColor: capitalDesignTokens.semanticColors.background.secondary,
    border: `1px solid ${capitalDesignTokens.semanticColors.border.primary}`,
    width: 'fit-content',
    maxWidth: '100%'
  },
  divider: {
    marginX: '8px'
  },
  modeSwitch: {
    display: 'flex',
    height: '32px'
  },
  iconButton: {
    width: '14px',
    height: '14px'
  },
  select: {
    width: '100%'
  },
  selectContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '74px',
    '& .MuiInputBase-root': {
      margin: '0px'
    }
  },
  storyNavigation: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '160px',
    '& .MuiTypography-root': {
      fontWeight: 400,
      minWidth: '80px'
    }
  },
  toggleButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: capitalDesignTokens.foundations.typography.fontSize.bodyDefault,
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.normal,
    gap: '8px',
    '&.Mui-selected': {
      backgroundColor: capitalDesignTokens.componentColors.primaryIdle,
      color: capitalDesignTokens.foundations.colors.white
    }
  },
  toggleButtonIcon: {
    width: '16px',
    height: '16px'
  }
});
